import React, { useState } from 'react';
import { BiX } from 'react-icons/bi';
import * as styles from './styles';
import { modalStyles } from './CreateInvoiceGroupModal';
import { Field } from './Master';

interface IFindCriteria {
    clientNo: string;
    prospectNo: string;
    sectionNo: string;
}

interface IProps {
    isOpen: boolean;
    onClose: () => void;
    onFind: (criteria: IFindCriteria) => void;
}

const FindInvoicesModal: React.FC<IProps> = ({ isOpen, onClose, onFind }) => {
    const [criteria, setCriteria] = useState<IFindCriteria>({ clientNo: '', prospectNo: '', sectionNo: '' });

    const handleOk = () => {
        onFind(criteria);
        onClose();
    };

    if (!isOpen) {
        return null;
    }

    return (
        <div style={modalStyles.modalOverlay} onClick={onClose}>
            {/* Added width override here to restrict size */}
            <div
                style={{
                    ...modalStyles.modalContent,
                    width: '400px',
                    maxWidth: '90vw',
                }}
                onClick={(e) => e.stopPropagation()}
            >
                {/* Header */}
                <div style={modalStyles.modalHeader}>
                    <h3 style={modalStyles.modalTitle}>Find Invoices to Post</h3>
                    <button onClick={onClose} style={modalStyles.iconButton}>
                        <BiX size={24} />
                    </button>
                </div>

                {/* Body - Increased Padding */}
                <div style={{ padding: '2rem', display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
                    <Field
                        label="Client No."
                        value={criteria.clientNo}
                        editable={true}
                        onChange={(val) => setCriteria({ ...criteria, clientNo: val })}
                    />
                    <Field
                        label="Prospect No."
                        value={criteria.prospectNo}
                        editable={true}
                        onChange={(val) => setCriteria({ ...criteria, prospectNo: val })}
                    />
                    <Field
                        label="Section No."
                        value={criteria.sectionNo}
                        editable={true}
                        onChange={(val) => setCriteria({ ...criteria, sectionNo: val })}
                    />
                </div>

                {/* Footer */}
                <div style={modalStyles.modalFooter}>
                    <button onClick={onClose} style={styles.buttonSecondary}>
                        Cancel
                    </button>
                    <button onClick={handleOk} style={{ ...styles.buttonPrimary, marginLeft: '0.5rem', width: '80px' }}>
                        OK
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FindInvoicesModal;



// WEBPACK FOOTER //
// ./src/components/leases/sections/FindInvoicesModal.tsx